export function isUnavailableITError(error) {
  const status = error?.response?.status;
  // A 404 with a detail is a real "not found" answer from the API, not a missing module.
  if (status === 404) return !error.response.data?.detail;
  return status === 405 || status === 501 || !error?.response;
}

// FastAPI returns `detail` as a string, or as a list of {loc, msg} for 422 validation errors.
function formatDetail(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        const field = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== 'body').join('.') : '';
        const message = item?.msg || (typeof item === 'string' ? item : '');
        return field ? `${field}: ${message}` : message;
      })
      .filter(Boolean)
      .join('; ');
  }
  return '';
}

export function getITErrorMessage(error, fallback) {
  if (isUnavailableITError(error)) {
    return 'El modulo IT no esta disponible en el backend actual.';
  }

  return formatDetail(error?.response?.data?.detail) || fallback;
}
